export const SET_DEVICE = "SET_DEVICE";
export const SET_PLATFORM = "SET_PLATFORM";
export const SET_DEVICE_OS = "SET_DEVICE_OS";
export const SET_IS_MOBILE = "SET_IS_MOBILE";
export const SET_FCM_TOKEN = "SET_FCM_TOKEN";
export const SET_DEVICE_TOKEN = "SET_DEVICE_TOKEN";
export const CREATE_USER_DEVICE = "CREATE_USER_DEVICE";
export const NOTIFICATIONS_REGISTERED = "NOTIFICATIONS_REGISTERED";